type IconProps = {
  color?: string;
  size?: number;
  className?: string;
};

/** For use in nav/sidebar: inherits text color and 20px size */
export function IconProducedOutputForNav({
  className,
}: {
  className?: string;
}) {
  return (
    <IconProducedOutput
      className={className}
      color="currentColor"
      size={20}
    />
  );
}

export function IconProducedOutput({
  color = "#3D3935",
  size = 26,
  className,
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M11.9918 1.73196C10.9127 1.22997 9.66708 1.22997 8.58803 1.73196L2.60387 4.51588C1.18097 5.17783 0.270996 6.60479 0.270996 8.17413V14.6382C0.270996 16.2196 1.19482 17.6552 2.63407 18.3104L8.61823 21.0345C9.45947 21.4175 10.3993 21.4971 11.2815 21.2734C11.714 21.1638 11.9771 20.7259 11.871 20.2926C11.7241 19.6925 11.646 19.0646 11.646 18.4174C11.646 14.0808 15.1605 10.5651 19.4967 10.5632C19.9452 10.563 20.3088 10.1993 20.3088 9.75071V8.17412C20.3088 6.60479 19.3988 5.17783 17.9759 4.51588L11.9918 1.73196Z"
        fill={color}
      />
      <path
        d="M17.9759 4.51392C19.1074 5.04033 19.9146 6.0505 20.1977 7.23135L10.9679 11.3345L10.9679 21.3378C10.5198 21.4142 10.0618 21.4143 9.61369 21.3381L9.6137 11.3353L0.382324 7.23C0.665738 6.04974 1.47271 5.04013 2.60381 4.51393L4.491 3.63598L14.3696 8.34008L15.9986 7.61591L6.08422 2.89479L8.58797 1.73001C9.66702 1.22802 10.9127 1.22802 11.9917 1.73001L17.9759 4.51392Z"
        fill={color}
      />
      <path
        d="M5.01026 15.3426C5.15649 14.9984 5.55403 14.838 5.8982 14.9842L7.84819 15.8127C8.19236 15.9589 8.35283 16.3564 8.2066 16.7006C8.06038 17.0448 7.66284 17.2052 7.31867 17.059L5.36867 16.2305C5.0245 16.0843 4.86404 15.6868 5.01026 15.3426Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5001 12.1868C16.0598 12.1868 13.2709 14.9757 13.2709 18.416C13.2709 21.8563 16.0598 24.6452 19.5001 24.6452C22.9403 24.6452 25.7292 21.8563 25.7292 18.416C25.7292 14.9757 22.9403 12.1868 19.5001 12.1868ZM18.823 20.5827C18.823 20.9566 19.1261 21.2598 19.5001 21.2598C19.874 21.2598 20.1772 20.9566 20.1772 20.5827V19.0931H21.6667C22.0407 19.0931 22.3438 18.79 22.3438 18.416C22.3438 18.0421 22.0407 17.7389 21.6667 17.7389H20.1772V16.2493C20.1772 15.8754 19.874 15.5723 19.5001 15.5723C19.1261 15.5723 18.823 15.8754 18.823 16.2493V17.7389H17.3334C16.9595 17.7389 16.6563 18.0421 16.6563 18.416C16.6563 18.79 16.9595 19.0931 17.3334 19.0931H18.823V20.5827Z"
        fill={color}
      />
    </svg>
  );
}
